import React from 'react';
import { ShoppingCart, MapPin, CreditCard, CheckCircle } from 'lucide-react';

const CheckoutProgress = ({ currentStep = 1 }) => {
    const steps = [
        { id: 1, name: 'Количка', icon: ShoppingCart },
        { id: 2, name: 'Адрес', icon: MapPin },
        { id: 3, name: 'Плащане', icon: CreditCard },
        { id: 4, name: 'Готово', icon: CheckCircle },
    ];

    return (
        <div className="w-full max-w-2xl mx-auto mb-8">
            <div className="flex items-center justify-between">
                {steps.map((step, index) => (
                    <React.Fragment key={step.id}>
                        {/* Step */}
                        <div className="flex flex-col items-center">
                            <div 
                                className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${
                                    step.id < currentStep 
                                        ? 'bg-green-500 text-white' 
                                        : step.id === currentStep
                                            ? 'bg-gradient-to-r from-amber-500 to-orange-500 text-white shadow-lg scale-110'
                                            : 'bg-slate-100 text-slate-400'
                                }`}
                            >
                                {step.id < currentStep ? (
                                    <CheckCircle className="h-6 w-6" />
                                ) : (
                                    <step.icon className="h-5 w-5" />
                                )}
                            </div>
                            <span className={`mt-2 text-sm font-medium ${
                                step.id <= currentStep ? 'text-slate-800' : 'text-slate-400'
                            }`}>
                                {step.name}
                            </span>
                        </div>

                        {/* Connector */}
                        {index < steps.length - 1 && (
                            <div className="flex-1 h-1 mx-4 rounded-full overflow-hidden bg-slate-100">
                                <div 
                                    className={`h-full bg-gradient-to-r from-amber-500 to-orange-500 transition-all duration-500 ${
                                        step.id < currentStep ? 'w-full' : 'w-0'
                                    }`}
                                />
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>
        </div>
    );
};

export default CheckoutProgress;
